// 四一爆料 站点模拟数据

export const years = ["全部", "2026", "2025", "2024"];

export const timelineTags = ["全部", "娱乐", "行业", "科技", "社会"];

export interface TimelineItem {
  year: string;
  month: string;
  tag: string;
  series: string;
  title: string;
  summary: string;
}

export const timelineData: TimelineItem[] = [
  {
    year: "2026",
    month: "09",
    tag: "科技",
    series: "大厂动向",
    title: "智能终端迭代引发的供应链讨论",
    summary: "围绕新一代旗舰产品的发布节奏，梳理了从预热到亮相的关键节点，整理了行业观察者的核心观点与争议焦点。",
  },
  {
    year: "2026",
    month: "08",
    tag: "娱乐",
    series: "爆点追踪",
    title: "一档综艺收官后的舆论余波",
    summary: "节目收官后话题持续发酵，按时间顺序回看了热搜走向与多轮声明，汇总各方回应的时间线。",
  },
  {
    year: "2026",
    month: "07",
    tag: "社会",
    series: "热点脉络",
    title: "暑期旅游旺季的服务质量讨论",
    summary: "从多个地区陆续出现的声音切入，整理了景区、平台与监管的三方回应，还原事件发展全貌。",
  },
  {
    year: "2026",
    month: "06",
    tag: "娱乐",
    series: "旧料翻新",
    title: "经典剧集重播引发的情怀回潮",
    summary: "老剧重播带动一阵回看热潮，我们把历年的片方动态、演员表态与网友考古内容做了串联整理。",
  },
  {
    year: "2025",
    month: "12",
    tag: "行业",
    series: "年度盘点",
    title: "内容行业年度十大趋势复盘",
    summary: "从短内容到长叙事，复盘一年间内容生产方式与消费习惯的变化，整理业内公开观点与数据。",
  },
  {
    year: "2025",
    month: "10",
    tag: "科技",
    series: "大厂动向",
    title: "开源模型生态竞争的关键节点",
    summary: "梳理多轮版本迭代与开放动作的时间顺序，对比各厂商对外口径，厘清舆论风向的转变过程。",
  },
  {
    year: "2025",
    month: "08",
    tag: "娱乐",
    series: "爆点追踪",
    title: "电影节话题之争全回顾",
    summary: "以奖项揭晓为线索，整理了提名、红毯、获奖感言等多个节点，串联起一场围绕行业标准的讨论。",
  },
  {
    year: "2025",
    month: "05",
    tag: "社会",
    series: "热点脉络",
    title: "城市公共空间管理议题梳理",
    summary: "汇总不同城市在夜间经济管理上的探索，还原各方立场与调整过程，形成一份脉络清晰的合集。",
  },
  {
    year: "2025",
    month: "02",
    tag: "行业",
    series: "数据说话",
    title: "短视频平台创作者分成调整",
    summary: "跟踪调整政策从发布到落地的全过程，整理了平台公告、创作者反馈与专家解读的多条线索。",
  },
  {
    year: "2024",
    month: "11",
    tag: "娱乐",
    series: "旧料翻新",
    title: "早年访谈被翻出后的二次传播",
    summary: "一段旧访谈因语境重新被讨论，我们按时间整理了最初播出、二次传播与当事人澄清等关键节点。",
  },
  {
    year: "2024",
    month: "09",
    tag: "科技",
    series: "大厂动向",
    title: "可穿戴设备市场的新一轮洗牌",
    summary: "从融资到发布再到出货数据，完整还原一个细分赛道在一年内经历的高开低走与重新定位。",
  },
  {
    year: "2024",
    month: "06",
    tag: "行业",
    series: "深度解读",
    title: "会员制订阅经济的冷思考",
    summary: "整理多家平台在会员权益上的反复调整，汇总用户与行业的真实声音，探讨可持续增长路径。",
  },
  {
    year: "2024",
    month: "03",
    tag: "社会",
    series: "热点脉络",
    title: "长假出行挤兑事件的时间还原",
    summary: "将一场出行拥堵事件拆解为发布、发酵、处置、复盘四个阶段，逐条还原时间线。",
  },
];

export interface SeriesCard {
  tag: string;
  name: string;
  count: string;
  desc: string;
}

export const seriesData: SeriesCard[] = [
  { tag: "追踪", name: "爆点追踪", count: "48 期", desc: "聚焦单起高关注事件，按日更新的线索追踪与声明汇总。" },
  { tag: "复盘", name: "热点脉络", count: "62 期", desc: "把一整条话题走向拆解成清晰的阶段与节点，方便回看。" },
  { tag: "盘点", name: "年度盘点", count: "12 期", desc: "每年末对行业与社会热点做结构化归纳，形成年度图谱。" },
  { tag: "考古", name: "旧料翻新", count: "35 期", desc: "当旧内容被重新讨论时，补齐语境，帮你看懂来龙去脉。" },
  { tag: "数据", name: "数据说话", count: "27 期", desc: "用公开数据还原事件规模，拒绝情绪化，只讲事实脉络。" },
  { tag: "解读", name: "深度解读", count: "19 期", desc: "跳出单一事件，探讨现象背后的行业规律与长期趋势。" },
];

export interface RecapItem {
  tag: string;
  title: string;
  desc: string;
  image: string;
}

export const recapData: RecapItem[] = [
  {
    tag: "精选",
    title: "补课指南：上半年你错过的 10 条关键脉络",
    desc: "从行业到娱乐，我们把上半年最值得回看的话题按时间顺序整理成一份系统清单。",
    image: "https://readdy.ai/api/search-image?query=editorial%20magazine%20grid%20of%20newspaper%20clippings%2C%20trending%20topics%20moodboard%2C%20warm%20paper%20background%2C%20minimal%20modern%20layout%2C%20soft%20neutral%20tones%20with%20red%20ink%20accents&width=800&height=560&seq=recap-1&orientation=landscape",
  },
  {
    tag: "时间线",
    title: "一场品牌风波的完整时间轴",
    desc: "我们把一桩多方参与的公开争议，从初发声到收尾逐条标出日期，还原每一步反应。",
    image: "https://readdy.ai/api/search-image?query=minimal%20editorial%20timeline%20infographic%20illustration%2C%20connected%20nodes%20and%20dates%2C%20warm%20paper%20palette%20with%20amber%20and%20ink%2C%20clean%20modern%20flat%20style&width=800&height=560&seq=recap-2&orientation=landscape",
  },
  {
    tag: "盘点",
    title: "年度热词背后的行业真相",
    desc: "从刷屏的热词出发，逆向梳理它们代表的行业变化，一篇文章看懂来龙去脉。",
    image: "https://readdy.ai/api/search-image?query=abstract%20editorial%20word%20cloud%20and%20trending%20topic%20board%2C%20warm%20neutral%20background%2C%20serif%20typography%20mood%2C%20modern%20newsroom%20aesthetic&width=800&height=560&seq=recap-3&orientation=landscape",
  },
];

export interface HotItem {
  rank: string;
  title: string;
  hot: string;
  tag: string;
}

export const hotList: HotItem[] = [
  { rank: "01", title: "某新机发布背后的产业链脉络", hot: "热度 9.8万", tag: "科技" },
  { rank: "02", title: "综艺决赛夜的舆论转折全记录", hot: "热度 8.7万", tag: "娱乐" },
  { rank: "03", title: "平台新规引发创作者集体讨论", hot: "热度 7.9万", tag: "行业" },
  { rank: "04", title: "节假日出行拥堵的复盘时间线", hot: "热度 6.3万", tag: "社会" },
  { rank: "05", title: "一档老剧考古内容重新刷屏", hot: "热度 5.1万", tag: "娱乐" },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqData: FaqItem[] = [
  {
    q: "四一爆料的合集内容是怎么整理的？",
    a: "我们以公开信息为依据，将同一事件或主题在不同时间点产生的动态，按时间先后逐条收录，再补充背景语境，形成可回看的脉络合集。每条内容都会标注所属系列与大致发生时间，方便按需浏览。",
  },
  {
    q: "历史时间线应该如何使用？",
    a: "首页的『历史时间线』板块支持按年份与主题筛选。你可以先用主题缩小范围，再在选中范围内按时间顺序浏览；也可以直接切到某一年份，查看该年度收录的关键节点。",
  },
  {
    q: "往期系列和单条时间线有什么区别？",
    a: "往期系列是一个长期更新的内容栏目（如爆点追踪、热点脉络），用于持续沉淀同类话题；时间线则更像是单条事件的详细年表。二者会互相链接，方便你在脉络与系列之间跳转。",
  },
  {
    q: "这里的回顾内容会定期更新吗？",
    a: "会的。编辑部会持续跟进值得回看的话题，把新出现的进展追加到对应时间线中，并在系列板块保持更新。你可以常回来查看，或用页脚的邮件反馈告诉我们你关心的方向。",
  },
  {
    q: "如何获取最新整理的更新提醒？",
    a: "你可以通过页面下方的投稿与反馈表单留下常用邮箱并说明希望关注的方向，编辑部会据此在后续内容整理中优先覆盖相关话题。",
  },
  {
    q: "内容中的时间顺序一定准确吗？",
    a: "我们依据公开报道与官方口径尽量做到准确，并在每条节点标注来源年份。由于部分事件存在多方表述差异，若你发现顺序或细节有出入，欢迎通过表单反馈，我们会核对后修正。",
  },
];